import './TopNavigation.scss';
import TopNavigation from '@trackman/web-shared-components/features/TopNavigation/TopNavigation';
import { ProfileMenu } from './ProfileMenu/ProfileMenu';
import { useMenuStore } from 'stores/MenuStore';
import { ReactComponent as CloseIcon } from '../../images/icons/Close.svg';
import { useNavigate } from 'react-router-dom';
import { DefaultRoutes } from 'Routes';

export const TopNav = () => {
  const navigate = useNavigate();
  const { isMobileMenuOpen, setIsMobileMenuOpen } = useMenuStore();

  return (
    <div className={`top-nav-wrapper ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}>
      <TopNavigation
        appName='Trackman University'
        onLogoClick={() => navigate(DefaultRoutes.Home)}
        navigation={[]}
        activeNavigationLabel={''}
        utilities={[{ key: 'profile-menu', component: <ProfileMenu /> }]}
        onHamburgerClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
      />
      {isMobileMenuOpen && (
        <button className='top-nav-close-btn' onClick={() => setIsMobileMenuOpen(false)} aria-label='Close menu'>
          <CloseIcon />
        </button>
      )}
    </div>
  );
};
